import React from 'react';

import { Link, LinkProps } from '@material-ui/core';

import { myStyles } from './styles';

interface LinkPropsLocal {
  selected?: string;
  disabled?: boolean;
  simplelink?: string;
}

const useStyles = myStyles();

export const CustomLink: React.FC<LinkProps & LinkPropsLocal> = props => {
  const classes = useStyles(props);
  const { selected, children, ...otherprops } = props;

  return (
    <div className={classes.customlink}>
      <Link
        className={`${classes.link} ${selected === 'true' ? 'selected' : ''}`}
        {...otherprops}
      >
        {children}
      </Link>
    </div>
  );
};
